import axios from "axios"
import { urls } from "utils-lib/builds"
import {
  TRIGGER_FORM_EMAIL_PENDING,
  TRIGGER_FORM_EMAIL_FAILED,
  TRIGGER_FORM_EMAIL_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: TRIGGER_FORM_EMAIL_PENDING,
})

export const failedAC = () => ({
  type: TRIGGER_FORM_EMAIL_FAILED,
})

export const fulfilledAC = (data) => ({
  type: TRIGGER_FORM_EMAIL_FULFILLED,
  payload: data,
})

export const triggerFormEmail = (payload) => (dispatch) => {
  const api = `TRIGGER_FORM_EMAIL`
  const url = `${urls.url[api]}?formData=${encodeURIComponent(
    JSON.stringify(payload),
  )}`

  dispatch(pendingAC())

  return axios
    .get(url)
    .then((r) => {
      dispatch(fulfilledAC(r?.data))
    })
    .catch(() => {
      dispatch(failedAC())
    })
}
